import { api } from '@/plugins/api';
import { UniqueIdentifierGenerator } from "@/utils/uniqueIdentifierGenerator"

const indexGenerator = new UniqueIdentifierGenerator()
const getDefaultState = () => {
  return {
    cartesDAffaires: [],
  }
}

const getDefaultValue = () => {
  return {
    internalIndex: -1,
    id: null,
    pp: null,
    pm: null,
    demandeInscription: null,
    label: null,
    nomDuLieuDeTravail: null,
    labelOrganisation: null,
    adresseIdentiqueALEmployeur: false,
    rue1: null,
    codePostal: null,
    ville: null,
    province: null,
    pays: null,
    active: true,
    tel: null,
    telDirectPoste: null,
    approchesDIntervention: [],
    domainesDePratique: [],
    fonction: null,
    titreDEmploi: null,
    pratiqueAutonome: false,
    nombreDHeureDeTravailEnPratiqueAutonome: null,
    installationHandicap: null,
    methodesDIntervention: [],
    servicesOfferts: [],
    typesDeClienteleDesservie: [],
    problemesSociauxGeneraux: [],
    therapieTechniquesDIntervention: [],
    expertiseLegalesActivitesReservees: [],
    serviceDeReferenceEnLigne: null,
    dateDEntreeEnFonction: null,
    dateDeFinDeFonction: null,
    organisation: {
      label: null,
      rue1: null,
      codePostal: null,
      ville: null,
      province: null,
      pays: null,
    },
    personal: false,
    principalPro: false,
  }
}

const state = getDefaultState()

// Ajout un identifiant unique utilisé pour les attributs key Vue.
const addInternalIndex = function (data) {
  if (data instanceof Array) {
    data.forEach((ca) => {
      ca.internalIndex = indexGenerator.nextValue()
    })
  }
}

const getters = {
  getCartesDAffaires: (state) => { return state.cartesDAffaires },
}

const mutations = {
  setCartesDAffaires (state, cartesDAffaires) {
    addInternalIndex(cartesDAffaires)
    
    state.cartesDAffaires = cartesDAffaires
  },
  setCarteDAffaireId (state, payload) {
    payload.carteDAffaire.id = payload.id
  },
  refreshStore (state, carteDAffaire) {
    const index = state.cartesDAffaires.indexOf(carteDAffaire)
    
    if (index !== -1) {
      state.cartesDAffaires.splice(index, 1, { ...carteDAffaire });
    }
  },
  addCarteDAffaire (state, carteDAffaire) {
    
    if (carteDAffaire.internalIndex === undefined || carteDAffaire.internalIndex < 0) {
      carteDAffaire.internalIndex = indexGenerator.nextValue()
    }
    
    state.cartesDAffaires.push(carteDAffaire)
  },
  removeCarteDAffaire (state, payload) {
    if (payload.item.id != null) {
      payload.item.dateDeFinDeFonction = payload.dateFin
      payload.item.active = false
    } else {
      state.cartesDAffaires.splice(state.cartesDAffaires.indexOf(payload.item), 1)
    }
  },
  majCarteDAffaire (state, carteDAffaire) {

    const oldCarteDAffaire = state.cartesDAffaires.find(a => a.id === carteDAffaire.id)
    const index = state.cartesDAffaires.indexOf(oldCarteDAffaire)
    
    // Maintient de la clef pour les listes Vue.
    carteDAffaire.internalIndex = oldCarteDAffaire.internalIndex
    
    state.cartesDAffaires[index] = carteDAffaire
  },
  updateDomainesDePratique (state, payload) {
    payload.carteDAffaire.domainesDePratique = payload.value
  },
  updateApprochesDIntervention (state, payload) {
    payload.carteDAffaire.approchesDIntervention = payload.value
  },
  updateMethodesDIntervention (state, payload) {
    payload.carteDAffaire.methodesDIntervention = payload.value
  },
  updateServicesOfferts (state, payload) {
    payload.carteDAffaire.servicesOfferts = payload.value
  },
  updateTypesDeClientelesDesservie (state, payload) {
    payload.carteDAffaire.typesDeClienteleDesservie = payload.value
  },
  updateProblemesSociauxGeneraux (state, payload) {
    payload.carteDAffaire.problemesSociauxGeneraux = payload.value
  },
  updateTherapieTechniquesDIntervention (state, payload) {
    payload.carteDAffaire.therapieTechniquesDIntervention = payload.value
  },
  updateExpertiseLegalesActivitesReservees (state, payload) {
    payload.carteDAffaire.expertiseLegalesActivitesReservees = payload.value
  }, 
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  async getDefaultCarteDAffairePro () {
    const carteDAffaire = getDefaultValue()
    carteDAffaire.internalIndex = indexGenerator.nextValue()

    return carteDAffaire
  },
  async fetchCartesDAffairesByContactId ({ commit }, contactId) {
    const response = await api.get(`cartesdaffaires/contacts/` + contactId);
    commit("setCartesDAffaires", response.data);
  },
  async fetchCartesDAffairesProByContactId ({ commit }, contactId) {
    const response = await api.get(`cartesdaffaires/contacts/` + contactId + `/pro`);
    commit("setCartesDAffaires", response.data);
  },
  async updateCarteDAffaire ({ commit }, carteDAffaire) {
    const response = await api.put(`cartesdaffaires`, carteDAffaire);
    commit("majCarteDAffaire", response.data);
  },
  async createCarteDAffaire ({ state, commit }, carteDAffaire) {
    carteDAffaire.id = null
    const response = await api.post(`cartesdaffaires`, carteDAffaire)

    if (response.data) {
      commit("setCarteDAffaireId", { carteDAffaire, id: response.data })
    }
  },
  async deleteCarteDAffaire ({ state, commit }, id) {
    const response = await api.delete(`cartesdaffaires/` + id);
    if (response.data == true) {
      commit("removeCarteDAffaire", state.cartesDAffaires.find(a => a.id == id))
    }
  },
  async fetchCartesDAffairesByDemandeInscriptionId ({ commit }, demandesInscriptionId) {
    const response = await api.get(`cartesdaffaires/demandesinscription/` + demandesInscriptionId)
    commit("SET_CARTEDAFFAIRE", response.data);
  },
  updateFromCanadaPost ({ commit }, payload) {

    if (!payload.address) {
      return
    }

    payload.carteDAffaire.rue1 = payload.address.Line1
    payload.carteDAffaire.codePostal = payload.address.PostalCode
    payload.carteDAffaire.ville = payload.address.City
    payload.carteDAffaire.statutEmployeur = payload.address.statutEmployeur

    if (payload.listeProvinces != null && payload.listeProvinces.length > 0) {
      payload.carteDAffaire.province = payload.address.ProvinceName == null
        ? null
        : payload.listeProvinces.find(p => p.lang00.toLowerCase() == payload.address.ProvinceName.toLowerCase() || (p.code != null && p.code.toLowerCase() == payload.address.ProvinceCode.toLowerCase()))
    }
    if (payload.listePays != null && payload.listePays.length > 0) {
      payload.carteDAffaire.pays = payload.address.CountryName == null
        ? null
        : payload.listePays.find(p => p.lang00.toLowerCase() == payload.address.CountryName.toLowerCase() || (p.code != null && p.code.toLowerCase() == payload.address.CountryIso2.toLowerCase()))
    }

    commit("refreshStore", payload.carteDAffaire)
  },
  setOrganisationToCarteDAffaire ({ commit }, payload) {
    if (payload.organisation) {
      payload.carteDAffaire.pm = payload.organisation.id
      payload.carteDAffaire.labelOrganisation = payload.organisation.label
      payload.carteDAffaire.organisation = payload.organisation
    } else {
      payload.carteDAffaire.organisation = null
    }

    commit("refreshStore", payload.carteDAffaire)
  },
  setAdresseOrganisationToCarteDAffaire ({ commit }, carteDAffaire) {

    if (carteDAffaire.organisation == null) {
      return
    }

    carteDAffaire.labelOrganisation = carteDAffaire.organisation.label
    carteDAffaire.nomDuLieuDeTravail = carteDAffaire.organisation.label
    carteDAffaire.rue1 = carteDAffaire.organisation.rue1
    carteDAffaire.ville = carteDAffaire.organisation.ville
    carteDAffaire.codePostal = carteDAffaire.organisation.codePostal
    carteDAffaire.province = carteDAffaire.organisation.province
    carteDAffaire.pays = carteDAffaire.organisation.pays

    commit("refreshStore", carteDAffaire)
  },
  updateOrganisationFromCanadaPost ({ commit }, payload) {

    if (!payload.address) {
      return
    }

    payload.organisation.rue1 = payload.address.Line1
    payload.organisation.codePostal = payload.address.PostalCode
    payload.organisation.ville = payload.address.City
    payload.organisation.statutEmployeur = payload.address.statutEmployeur

    if (payload.listeProvinces != null && payload.listeProvinces.length > 0 && payload.address.ProvinceName && payload.address.ProvinceName.length > 0) {
      payload.organisation.province = payload.address.ProvinceName == null
        ? null
        : payload.listeProvinces.find(p => p.lang00.toLowerCase() == payload.address.ProvinceName.toLowerCase() || (p.code != null && p.code.toLowerCase() == payload.address.ProvinceCode.toLowerCase()))
    }
    if (payload.listePays != null && payload.listePays.length > 0 && payload.address.CountryName && payload.address.CountryName.length > 0) {
      payload.organisation.pays = payload.address.CountryName == null
        ? null
        : payload.listePays.find(p => p.lang00.toLowerCase() == payload.address.CountryName.toLowerCase() || (p.code != null && p.code.toLowerCase() == payload.address.CountryIso2.toLowerCase()))
    }

    //commit("refreshStore", payload.carteDAffaire)
  },
  setPrincipal ({ state, commit }, carteDAffaire) {
    commit("refreshStore", carteDAffaire)
    
    for (const c1 of state.cartesDAffaires.filter(c => c.id != carteDAffaire.id && c.principalPro === true)) {
      commit("refreshStore", c1)
    }
  },
  resetModuleState ({ commit }) {
    commit('resetState')
  },
}

export default ({
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
})
